import script from "./SimpleEntry.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleEntry.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleEntry.vue?vue&type=style&index=0&id=5245375c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5245375c"]])

export default __exports__